export const selectFilterOptions = (state) => state.baseFilterOptions;
